<template>
  <div class="flex flex-col items-center justify-center h-full gap-4">
    <i class="iconify mingcute--chat-4-line text-4xl" />
    <div class="text-xl">{{ $t("Chats.selectChatOnTheLeft") }}</div>
  </div>
</template>
